module.exports = __webpack_public_path__ + "img/promo.8c723a27.jpg";